import { StripeTerminalError } from './StripeTerminalError';

export class StripeTerminalDisconnectError extends StripeTerminalError {
  constructor(message: unknown) {
    super(message);
    this.name = 'StripeTerminalDisconnectError';
  }
}
